import { createSlice } from "@reduxjs/toolkit";
import {
  getAppointmentByIdService,
  getAppointmentsService,
  createAppointmentService,
  updateAppointmentSService,
  deleteAppointmentSService,
} from "../services/appointments_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  appointmentsList: [],
  appointmentInfo: {},
};

const slice = createSlice({
  name: "appointments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getAppointmentsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appointmentsList = action.payload?.data?.data;
        console.log(state.servicesList);
      })
      .addCase(getAppointmentsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAppointmentsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAppointmentByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.appointmentInfo = action.payload?.data?.data;
        console.log(state.serviceInfo);
      })
      .addCase(getAppointmentByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAppointmentByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
